import { render } from "./IconMaps.vue?vue&type=template&id=674e9001"
import script from "./IconMaps.vue?vue&type=script&lang=js"
export * from "./IconMaps.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__